module.exports = __WEBPACK_EXTERNAL_MODULE_64__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/dashboard-common/dist/core/Model"
// module id = 64
// module chunks = 0